<template>
    <div>
        {{ $t('common.attach_file') }}

        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
                <v-icon color="primary" dark v-on="on"  @click="attachFile()">attach_file</v-icon>
            </template>
            <span>{{ $t('common.attach_file') }}</span>
        </v-tooltip>

        <v-dialog v-model="uploadDialog" max-width="60%">
            <v-card>
                <v-card-title>
                    <span class="headline">Chọn danh sách file để upload</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row v-for="(file, index ) in files" :key="file.id">
                        <v-col cols="12" sm="8">
                            <span class="text-no-wrap"> {{ (index + 1) + '.' }} {{ file.name }} </span>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-icon @click="deleteFileBeforeUpload(file)"> delete </v-icon>
                        </v-col>
                    </v-row>

                    <v-row>
                        <!-- <file-upload :multiple="true" v-model="files">
                            <v-btn> {{ $t('common.chosen_file') }} </v-btn>
                        </file-upload> -->
                        <v-file-input color="primary" hide-input multiple v-model="files"></v-file-input>
                    </v-row> 
                </v-container>

                <v-divider></v-divider>
                <v-toolbar flat>
                    <v-btn color="primary" width="120px" @click="cancelUpload">{{ $t('common.cancel') }}</v-btn>

                    <v-spacer> </v-spacer>

                    <v-btn color="primary" @click="uploadFileData" width="120px" class="mr-5">
                        {{ $t('common.ok') }}
                    </v-btn>                       
                </v-toolbar>
                </v-card-text>
            </v-card>

            <v-overlay :value="overlay" :z-index="0">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-dialog>
    </div>
</template>

<script>
    import i18n from '@/plugins/i18n';
    // import FileUpload from 'vue-upload-component';

    export default {
        name: 'upload-dialog',

        components: {
            // FileUpload: FileUpload
        },

        watch: {
            files(val) {
                val.forEach(file => {
                    if (file.size > 5 * 1024 * 1024) {
                        val.splice(file, 1);
                        alert("File " + file.name +  " đã chọn vượt quá 5M");
                    }
                });
            }
        },

        data: ()=> ({
            uploadDialog: false,
            files: [],
            overlay: false
        }),

        props: {
            
        },

        methods: {
            attachFile() {
                this.files = [];
                this.uploadDialog = true;
            },

            cancelUpload() {
                this.uploadDialog = false;
            },

            deleteFileBeforeUpload(file) {
                if (Array.isArray(this.files) && this.files.length > 0) {
                    const agree = confirm(i18n.t('common.confirm_delete'));
                    if (agree) {
                        this.files.splice(this.files.indexOf(file), 1);
                    }
                }
            },

            async uploadFileData() {
                this.overlay = true;
                const self = this;
                if (Array.isArray(self.files) && self.files.length > 0) {
                    let formData = new FormData();

                    self.files.forEach(file => {
                        formData.append('files', file);
                    });

                    try {
                        const response =  await self.$httpUpload.post("/uploadFile/", formData);

                        if (Array.isArray(response.data) && response.data.length > 0) {
                            self.uploadDialog = false;
                            this.overlay = false;
                            this.$emit('uploadFileSuccess', response.data)
                        } else {
                            alert('Upload error!');
                        }
                    } catch(e) {
                        console.log(e.stack);
                        alert("Request error!");
                    }
                    
                }     
            },
        }
    }
</script>
